var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-link"},[_c('v-popover',{attrs:{"offset":"16","classes":['tooltip'],"show":true,"auto-hide":false,"placement":"auto"}},[_c('a',{staticClass:"tooltip-target"},[_vm._v(_vm._s(_vm.targetText))]),_vm._v(" "),_c('template',{slot:"popover"},[_vm._t("default")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }